import _ from 'underscore';
import { useCallback, useContext } from 'react';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { RecommendationContext } from '@bingads-webui-campaign-react/perf-max-recommendation';
import { useAssetLibraryImagePicker } from '@bingads-webui-campaign-react/add-image-hooks';

const getProcessedCreative = (finalUrl, image, creative) => ({
  data: {
    FinalUrls: [finalUrl],
    image,
    creativeData: {
      creativeId: image.id,
      creativeMeta: {
        ...creative,
      },
    },
  },
});

export const useCreateAds = ({
  oDataConfig,
  permissions,
  aid,
  onCreateAds,
}) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);
  const [{ finalUrl }] = useContext(RecommendationContext);

  const advertiserCustomerId = _.get(serverContext, ['CurrentAccount', 'AdvertiserCustomerID']);

  const {
    addCreatives: addToAssetLibrary,
  } = useAssetLibraryImagePicker({
    cid: advertiserCustomerId.toString(),
    aid: aid.toString(),
    oDataConfig,
    onNewImageSelected: _.noop,
    i18n,
    permissions,
    isDisplayAds: true,
  });

  return useCallback(creativesToAdd => addToAssetLibrary({ creativeData: creativesToAdd })
    .then((savedImages) => {
      const creatives = savedImages.map((savedImage, index) => getProcessedCreative(finalUrl, savedImage, creativesToAdd[index]));
      onCreateAds(creatives);
      return creatives;
    }), [addToAssetLibrary, finalUrl, onCreateAds]);
};
